import CustomPalette from '@/theme/CustomPalette'
import { SxProps, Theme } from '@mui/material'

export const selectedContainer: SxProps<Theme> = {
  fontSize: '16px',
  color: CustomPalette.NightBlue200,
  mr: 2.5,
}

export const menuContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  fontSize: '14px',
}

export const selectLanguageContainer: SxProps<Theme> = {
  '& .MuiSelect-icon': {
    color: CustomPalette.NightBlue200,
    fontSize: '19px',
  },
  '&:before, &:after': { display: 'none' },
}
